import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  $garColPoints,
  queryGarbageCollectionPoints,
  getPoints4map,
  changeClickedPoint,
  getStatusIconName,
  getAccountPointData4map,
} from "../logics/garbageCollectionPoints";
import { $routes, queryRoutes } from "../logics/routes";
import { RoutePanel } from "../molecules/RouteBlock";
import { CoordinateDecPoints } from "../../../common/config/vars";
import { useStore } from "effector-react";
import { YMaps, Map, Placemark } from "react-yandex-maps";
import { ICollectionPoint } from "../logics/garbageCollectionPoints";
import { $accounts, $selectedAccountIdx, IAccountPoint } from "../../../common/accounts2";
import { AccountPointsFilterPanel } from "../molecules/AccountPointsFilterBlock";
import { $SiteColors } from "../../../common/config/company-atts";

interface IMapBlock {
  lat?: number;
  lng?: number;
  zoom?: number;
}

interface IMapState {
  center: number[],
  zoom: number,
}

export const MapBlock = ({ lat = 56.0365, lng = 92.9168, zoom = 16 }: IMapBlock) => {
  const [mapCenter, setMapCenter] = useState([lat, lng])
  const [mapZoom, setMapZoom] = useState(zoom)
  const [accPointChoosedIdx, setAccPointChoosedIdx] = useState(-1)
  const [accPoints, setAccPoints] = useState<IAccountPoint[]>()

  const [points4map, setPoints4map] = useState<ICollectionPoint[]>([]);

  const {accounts} = useStore($accounts)
  const selAccIdx = useStore($selectedAccountIdx)

  const updMapPoints = () => {
    if(accPointChoosedIdx  < 0) {
      setPoints4map(getPoints4map(points, routes));
      setMapZoom(15)
    } else if(accPoints != undefined) {
      let choosedPoint = accPoints[accPointChoosedIdx]
      if(choosedPoint != undefined) {
        setPoints4map(getAccountPointData4map(choosedPoint, routes))
        setMapCenter([choosedPoint.pointLatitude, choosedPoint.pointLongitude])
        setMapZoom(16)
      }
    }
  }

  useEffect(() => {
    updMapPoints()
  }, [accPointChoosedIdx])

  useEffect(() => {
    if(selAccIdx > -1 && accounts[selAccIdx].garbageCollectionPoints) {
      setAccPoints(accounts[selAccIdx].garbageCollectionPoints)
    }
  }, [accounts])

  useEffect(() => {
    //@ts-ignore
    if(mapRef != null) mapRef.setCenter(mapCenter)
  }, [mapCenter])

  useEffect(() => {
    //@ts-ignore
    if(mapRef != null) mapRef.setZoom(mapZoom)
  }, [mapZoom])



  const [mapRef, setMapRef] = useState<React.Ref<any>> (null)
  const getPointData = (index: any) => {
    return {
      balloonContentBody: "placemark <strong>balloon " + index + "</strong>",
      clusterCaption: "placemark <strong>" + index + "</strong>",
    };
  };
  const getPointOptions = (status: string) => {
    return {
      preset: getStatusIconName(status),
    };
  };
  const mapState = {
    center: [lat, lng],
    zoom: zoom,
    //behaviors: ["default", "scrollZoom"],
  } 

  const onCLick = (
    pointId: any,
    idxRoute: any,
    idxPoint: any,
    idxInRoute: any
  ) => {
    //console.log("POINT_IDX:", pointId);
    //console.log("ROUTE_IDX:", idxRoute);
    changeClickedPoint({
      pointId: pointId,
      routeIdx: idxRoute,
      pointIdx: idxPoint,
      idxInRoute: idxInRoute,
    });
    /*e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation();*/
    return false;
  };

  const onBoundsChange = (e: any) => {
    //console.log("BOUNDS:", getDistanceBetween2pointsInM(e.get('target').getBounds()))
    //console.log("RAD:", getRadiusCoeff(e.get('newZoom')))
    //console.log("ZOOM:", e.get('newZoom'))
    let center = e.get("target").getCenter();
    //console.log("--->", e.get("target").setCenter([3,5])) //IMPORTANT_IMPORTANT
    //changeClickedPoint(null);
    queryGarbageCollectionPoints(center);
  };



  const routes = useStore($routes);
  const points = useStore($garColPoints);
  useEffect(() => {
    queryRoutes();
    /*setAccPointChoosedIdx(0)*/
  }, []);
  useEffect(() => {
    updMapPoints()
    setPoints4map(getPoints4map(points, routes));
  }, [points]);

  const history = useHistory();
  function goBack() {
    //setMapZoom(14)
    //setMapCenter([lat-6, lng])
    history.goBack();
    //console.log("points_for_map44:", mapRef);
  }

  return (
    <section className="page__content">
      <div className="page__title-container">
        <nav className="page__navigation page__navigation_title-bar">
          <button
            type="button"
            className="page__navigation-button page__navigation-button_title-bar"
            onClick={goBack}
          >
            Назад
          </button>
        </nav>
        <h1 className="page__title page__title_no-padding" style={{color:$SiteColors.getState().titleColor}}>
          График движения мусоровозов
        </h1>
      </div>
      <div className="page__map">
        <RoutePanel routes={routes} points={points4map} isHidden={false} />
        <AccountPointsFilterPanel setAccChoosedPointIdx={setAccPointChoosedIdx} accChoosedPointIdx={accPointChoosedIdx} accPoints={accPoints == undefined ? [] : accPoints}/>
        <YMaps>
          <Map
            instanceRef={e=> {setMapRef(e)}}
            style={{ width: "100%", height: "100%" }}
            defaultState={{center: [lat, lng], zoom: zoom}}
            onBoundsChange={(e: Event) => onBoundsChange(e)}
          >
            {points4map.map((point, i) => (
              <Placemark
                onClick={() =>
                  onCLick(point.id, point.idxRoute, i, point.idxInRoute)
                }
                id={i}
                key={i}
                geometry={[
                  point.pointLatitude / CoordinateDecPoints,
                  point.pointLongitude / CoordinateDecPoints,
                ]}
                properties={getPointData(i)}
                options={getPointOptions(point.pointStatus)}
              />
            ))}
          </Map>
        </YMaps>
      </div>
    </section>
  );
};
